import classNames from 'classnames';
import {
  NewBookingIcon,
  AwaitBookingIcon,
  ConfirmBookingIcon,
  LineBookingIcon,
  CanceledBookingIcon,
} from '../../../assets/icons';

import styles from './ListHeader.module.scss';

type HeaderProps = {
  handlerFilterNew: () => void;
  handlerFilterConfirm: () => void;
  handlerFilterAwait: () => void;
  handlerFilterLine: () => void;
  handlerFilterCanceled: () => void;
  isFilterNew: boolean;
  isFilterConfirm: boolean;
  isFilterAwait: boolean;
  isFilterLine: boolean;
  isFilterCanceled: boolean;
  disableNew?: boolean;
  disableLine?: boolean;
  compact?: boolean;
};

const ListHeader = ({
  handlerFilterNew,
  handlerFilterConfirm,
  handlerFilterAwait,
  handlerFilterLine,
  handlerFilterCanceled,
  isFilterNew,
  isFilterConfirm,
  isFilterAwait,
  isFilterLine,
  isFilterCanceled,
  disableNew = false,
  disableLine = false,
  compact = false,
}: HeaderProps) => {
  return (
    <div className={classNames(styles.container, compact && styles.compact)}>
      <button
        type="button"
        disabled={disableNew}
        className={classNames(styles.btn, compact && styles.compactButton, isFilterNew && styles.activeBtn)}
        onClick={handlerFilterNew}
      >
        <NewBookingIcon />
        <div className={styles.title}>Новая бронь</div>
      </button>
      <button
        type="button"
        className={classNames(styles.btn, compact && styles.compactButton, isFilterConfirm && styles.activeBtn)}
        onClick={handlerFilterConfirm}
      >
        <ConfirmBookingIcon />
        <div className={styles.title}>Бронь подтверждена</div>
      </button>
      <button
        type="button"
        className={classNames(styles.btn, compact && styles.compactButton, isFilterAwait && styles.activeBtn)}
        onClick={handlerFilterAwait}
      >
        <AwaitBookingIcon />
        <div className={styles.title}>Ожидает подтверждения</div>
      </button>
      <button
        type="button"
        disabled={disableLine}
        className={classNames(styles.btn, compact && styles.compactButton, isFilterLine && styles.activeBtn)}
        onClick={handlerFilterLine}
      >
        <LineBookingIcon />
        <div className={styles.title}>Бронь в очереди</div>
      </button>
      <button
        type="button"
        className={classNames(styles.btn, compact && styles.compactButton, isFilterCanceled && styles.activeBtn)}
        onClick={handlerFilterCanceled}
      >
        <CanceledBookingIcon />
        <div className={styles.title}>Бронь отменена</div>
      </button>
    </div>
  );
};

export default ListHeader;
